import { EditOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import {
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Switch,
  Table,
  Tooltip,
  Typography
} from 'antd';
import React, { useEffect, useState } from 'react';
import { errorHandler, gruposSistema } from '../../utils';

// const originData = [];
let rolesByTipoAutorizacion = [];
// let newDataList = [];

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const [
    checkedAutorizacionEspecial,
    setCheckedAutorizacionEspecial
  ] = useState(false);

  const onChangeSwitch = (checked) => {
    setCheckedAutorizacionEspecial(checked);
  };

  let inputNode = <Input />;
  if (inputType === 'number') {
    <InputNumber />;
  } else if (inputType === 'boolean') {
    inputNode = (
      <Switch
        checked={checkedAutorizacionEspecial}
        checkedChildren="Si"
        unCheckedChildren="No"
        onChange={onChangeSwitch}
      />
    );
  }
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`
            }
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const TableRoles = ({
  initialValues,
  idAutorizacionConfig,
  setNewDataList
}) => {
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;
  const getInitialValues = () => {
    if (initialValues.length > 0) {
      const autorizacionConfigDetalle = initialValues.map((item, index) => {
        return {
          ...item,
          key: index.toString(),
          rol: gruposSistema[item.rol],
          rol_value: item.rol,
          autorizacion_especial: item.autorizacion_especial
          // autorizacion_especial_value: item.autorizacion_especial
        };
      });
      setData(autorizacionConfigDetalle);
    } else {
      const newInitialValues = [];
      for (let i = 0; i < Number(rolesByTipoAutorizacion.length); i += 1) {
        newInitialValues.push({
          key: i.toString(),
          rol: gruposSistema[rolesByTipoAutorizacion[i]],
          rol_value: rolesByTipoAutorizacion[i],
          cantidad: Number(0),
          autorizacion_especial: false
          // autorizacion_especial_value: false
        });
      }
      setData(newInitialValues);
    }
  };
  const edit = (record) => {
    form.setFieldsValue({
      rol: '',
      cantidad: Number(0),
      autorizacion_especial: false,
      ...record
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      // const newData = lodashClonedeep(data);
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        const dataNuevo = {
          ...item,
          ...row,
          // autorizacion_especial: row.autorizacion_especial,
          // autorizacion_especial_value: row.autorizacion_especial === 'SI',
          id_autorizacion_config: item.id_autorizacion_config
            ? item.id_autorizacion_config
            : idAutorizacionConfig
        };
        newData.splice(index, 1, dataNuevo);

        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
      setNewDataList(newData);
    } catch (errInfo) {
      errorHandler(errInfo);
    }
  };
  const columns = [
    {
      title: 'Rol',
      dataIndex: 'rol',
      width: '40%',
      editable: true
    },
    {
      title: 'Cantidad',
      dataIndex: 'cantidad',
      width: '20%',
      editable: true
    },
    {
      title: 'Autorización Especial',
      dataIndex: 'autorizacion_especial',
      width: '20%',
      editable: true,
      render: (record) => {
        return record ? 'Si' : 'No';
      }
    },
    {
      title: 'Acciones',
      dataIndex: 'acciones',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key, idAutorizacionConfig)}
              style={{
                marginRight: 8
              }}
            >
              Guardar
            </Typography.Link>
            <Popconfirm
              title="¿Está seguro que desea cancelar?"
              onConfirm={cancel}
            >
              Cancelar
            </Popconfirm>
          </span>
        ) : (
          <>
            <Tooltip title="Editar">
              <EditOutlined
                disabled={editingKey !== ''}
                onClick={() => edit(record)}
                style={{ color: 'rgba(0,0,0,.45)' }}
              />
            </Tooltip>
          </>
        );
      }
    }
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    let type = 'text';
    if (col.dataIndex === 'cantidad') {
      type = 'number';
    } else if (col.dataIndex === 'autorizacion_especial') {
      type = 'boolean';
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: type,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: col.dataIndex !== 'rol' && isEditing(record)
      })
    };
  });

  useEffect(() => {
    getInitialValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form form={form} component={false}>
      {data && (
        <Table
          components={{
            body: {
              cell: EditableCell
            }
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={{
            onChange: cancel
          }}
          rowKey={(record) => record.key}
        />
      )}
    </Form>
  );
};

const ConfiguracionRolesModal = ({
  roles,
  initialValues,
  setRolConfigList,
  idAutorizacionConfig,
  rowConfig,
  extra
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newDataList, setNewDataList] = useState([]);

  rolesByTipoAutorizacion = roles;

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    const list = newDataList.map((item) => {
      const element = item;
      element.rowConfig = rowConfig;
      return element;
    });
    setRolConfigList(list);
    setIsModalOpen(false);
    await extra.setearArreglo(list);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };
  const clearAll = () => {
    // TODO: Reset de datos al cancelar y guardar los datos
  };

  return (
    <>
      <Tooltip title="Roles">
        <Button
          icon={<UsergroupAddOutlined />}
          type="text"
          size="middle"
          onClick={showModal}
        />
      </Tooltip>

      <Modal
        title="Configuración de Roles"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
      >
        <TableRoles
          initialValues={initialValues}
          idAutorizacionConfig={idAutorizacionConfig}
          {...{ setNewDataList }}
        />
      </Modal>
    </>
  );
};
export default ConfiguracionRolesModal;
